import { render, staticRenderFns } from "./termsAndConditionsModal.vue?vue&type=template&id=962854e0"
import script from "./termsAndConditionsModal.vue?vue&type=script&lang=js"
export * from "./termsAndConditionsModal.vue?vue&type=script&lang=js"
import style0 from "./termsAndConditionsModal.vue?vue&type=style&index=0&id=962854e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports